import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Grid, Button, Input, TextField } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Autocomplete from '@mui/material/Autocomplete';
import { ToastContainer, toast } from 'react-toastify';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const showDuplicateEntryAlert = () => {
    MySwal.fire({
        title: <strong>Duplicate Entry</strong>,
        html: <p>FinishedItCode is already present!</p>,
        icon: 'info',
        confirmButtonColor: '#1976d2', // Change this color as needed
        confirmButtonText: 'OK',
    });
};

function ProdFormulaMaster(props) {
    const [FormulaNo, setFormulaNo] = useState(0);
    const [FinishedItCode, setFinishedItCode] = useState(0);
    const [PerQty, setPerQty] = useState(0.0);
    const [Narration, setNarration] = useState('');
    const [rows, setRows] = useState([{ RawItCode: 0, Qty: 0.0, PerKg: 0.0 }]);
    const [totalQty, setTotalQty] = useState(0);
    const [totalKg, setTotalKg] = useState(0);

    const [DeptCode, setDeptCode] = useState('');
    const [UserID, setUserID] = useState('');
    const [units, setUnits] = useState([]);
    const [editFormulaNo, setEditFormulaNo] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);

    const [deleteEntryNo, setDeleteEntryNo] = useState(null);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [formMode, setFormMode] = useState('add');
    const [editCasteId, setEditCasteCode] = useState(null);
    const [showGrid, setShowGrid] = useState(true);
    const [ProductMasterEntries, setProductMasterEntries] = useState([]);
    const [itemMasterEntries, setItemMasterEntries] = useState([]);
    const [packingMasterEntries, setPackingMasterEntries] = useState([]);


    useEffect(() => {
        fetchProductMaster();
        fetchItemMaster();
        fetchPackingMaster();
    }, []);

    const fetchProductMaster = async () => {
        try {
            const response = await axios.get('https://www.wingap.net.in/api/prodForm');
            setProductMasterEntries(response.data);
            const maxEntryNo = calculateMaxEntryNo(response.data);
            const nextEntryNo = maxEntryNo + 1;
            setFormulaNo(nextEntryNo);
            //console.log(response.data);
        } catch (error) {
            console.log('error:', error);
        }
    };


    const calculateMaxEntryNo = (entries) => {
        let maxEntryNo = 0;
        for (const entry of entries) {
            if (entry.FormulaNo > maxEntryNo) {
                maxEntryNo = entry.FormulaNo;
            }
        }
        return maxEntryNo;
    };

    const fetchPackingMaster = async () => {
        try {
          const response = await axios.get('https://www.wingap.net.in/api/packing');
          setPackingMasterEntries(response.data);
        } catch (error) {
          console.log('error:', error);
        }
      };

    const fetchItemMaster = async () => {
        try {
            const response = await axios.get("https://www.wingap.net.in/api/items-master");
            setItemMasterEntries(response.data.sort((a, b) => a.ItCode - b.ItCode));
        } catch (error) {
            console.log("error:", error);
        }
    };

    const addProduct = async () => {
        if ((!props.canAdd)) {
              const action = "Save";
              toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
              return;
            }
        try {
            const productData = {
                FormulaNo: Number(FormulaNo),
                FinishedItCode: Number(FinishedItCode),
                PerQty: Number(PerQty),
                Narration,
                UserID: props.name,
                items: rows,
            };

            await axios.post('https://www.wingap.net.in/api/prodForm', productData);
            toast.success('Formula Added Successfully....', { autoClose: 650 });
            setPerQty(0.0);
            setNarration('');
            setFinishedItCode(0);
            setRows([{ RawItCode: 0, Qty: 0.0, PerKg: 0.0 }]);
            fetchProductMaster();
        } catch (error) {
            console.log('Error:', error);
        }
    };

    const updateProduct = async () => {
        if ((!props.canEdit)) {
              const action = "Update";
              toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
              return;
            }
        try {
            const updatedProductData = {
                FinishedItCode: Number(FinishedItCode),
                PerQty: Number(PerQty),
                Narration,
                UserID: props.name,
                items: rows,
            };
            await axios.put(`https://www.wingap.net.in/api/prodForm/`, updatedProductData);
            resetForm();
            setFormMode('add');
            setEditFormulaNo(null);
            fetchProductMaster();
        } catch (error) {
            console.log('Error updating product:', error);
        }
    };

    const handleDeleteConfirmation = async () => {
        try {
            if (deleteEntryNo) {
                await deleteProduct(deleteEntryNo);
                setOpenConfirmation(false);
            }
        } catch (error) {
            console.log('Error:', error);
        }
    };

    const deleteProduct = async (FormulaNo) => {
        if (!props.canDelete) {
                  toast.error("You do not have permission to Delete.", { autoClose: 800 });
                  return;
                }
        try {
            await axios.delete(`https://www.wingap.net.in/api/prodForm/${FormulaNo}`, {
                headers: {
                    'username': props.name,
                },
            });
            fetchProductMaster();
        } catch (error) {
            console.log('Error:', error);
        }
    };

    const setEditForm = (room) => {
        setFormMode('edit');
        setFinishedItCode(room.FinishedItCode);
        setPerQty(room.PerQty);
        setNarration(room.Narration);
        setUserID(room.UserID);

        const filteredEntries = ProductMasterEntries.filter(entry => entry.FinishedItCode == room.FinishedItCode);

        const newRows = filteredEntries.map(filteredEntry => {
            const item = itemMasterEntries.find(item => item.ItCode === filteredEntry.RawItCode);
            return {
                RawItCode: item ? item.ItCode : 0,
                Qty: filteredEntry.Qty,
                PerKg: filteredEntry.PerKG,
            };
        });
        setRows(newRows);
        setShowGrid(false);
    };

    const handleSaveProduct = async () => {
        if (formMode === 'add') {
            await addProduct();
        } else if (formMode === 'edit') {
            await updateProduct();
        }
    };

    const resetForm = () => {
        setFinishedItCode(0);
        setPerQty(0.0);
        setNarration('');
        setRows([{ RawItCode: 0, Qty: 0.0, PerKg: 0.0 }]);
    };

    const handleshowandhide = () => {
        setFormMode('add');
        setShowGrid(!showGrid);
        setUnits(units);
        setFinishedItCode('');
        setPerQty('');
        setNarration('');
        fetchProductMaster();
        setRows([{ RawItCode: 0, Qty: 0.0, PerKg: 0.0 }]);
    };

    const handleCancel = () => {
        setFormMode('add');
        setEditCasteCode('');
        setPerQty('');
        setNarration('');
        /* setQty('');
        setPerKg('');
        setRawItCode(''); */
        setUserID('');
        fetchProductMaster();
    };

    const componentPDF = useRef();

    const generatePDF = useReactToPrint({
        content: () => componentPDF.current,
        documentTitle: "Caste Data",
        onAfterPrint: () => alert("Pdf downloaded"),
        pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }

        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
    });

    const handleFinishedItCodeChange = (newValue) => {
        if (newValue) {
            const isFinishedItCodeValid = ProductMasterEntries.some(entry => entry.FinishedItCode == newValue.ItCode);

            if (isFinishedItCodeValid) {
                setFinishedItCode(newValue.ItCode);
                setDialogOpen(true);
                showDuplicateEntryAlert();
                setFormMode('edit');

                const filteredEntries = ProductMasterEntries.filter(entry => entry.FinishedItCode == newValue.ItCode);

                const newRows = filteredEntries.map(filteredEntry => {
                    const item = itemMasterEntries.find(item => item.ItCode === filteredEntry.RawItCode);
                    return {
                        RawItCode: item ? item.ItCode : 0,
                        Qty: filteredEntry.Qty,
                        PerKg: filteredEntry.PerKG,
                    };
                });

                setRows(newRows);
                if (filteredEntries.length > 0) {
                    setFormulaNo(filteredEntries[0].FormulaNo);
                    setPerQty(filteredEntries[0].PerQty);
                    setNarration(filteredEntries[0].Narration || '');
                } else {
                    setPerQty(0);
                    setNarration('');
                    fetchProductMaster();
                }
            } else {
                setFormMode('add');
                setFinishedItCode(newValue.ItCode);
                setRows([]);
                setPerQty(0);
                setNarration('');
                fetchProductMaster();
            }
        } else {
            setFormMode('add');
            setFinishedItCode('');
            setRows([]);
            setPerQty(0);
            setNarration('');
        }
    };


    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    /* const handleRowChange = (index, field, value) => {
        const updatedRows = rows.map((row, i) => {
            if (i === index) {
                return {
                    ...row,
                    [field]: field === 'RawItCode' ? Number(value) : field === 'Qty' || field === 'PerKg' ? parseFloat(value) || 0 : value
                };
            }
            return row;
        });
        setRows(updatedRows);
    }; */
    useEffect(() => {
        const totalQty = rows.reduce((total, row) => total + row.Qty, 0);
        const totalKg = rows.reduce((total, row) => total + parseFloat(row.PerKg || 0), 0);

        setTotalKg(totalKg);
        setTotalQty(totalQty);
    }, [rows]); 

    const handleRowChange = (index, field, value) => {
        const updatedRows = rows.map((row, i) => {
            if (i === index) {
                let updatedRow = { ...row, [field]: field === 'RawItCode' ? Number(value) : field === 'Qty' || field === 'PerKg' ? parseFloat(value) || 0 : value };
    
                if (field === 'RawItCode') {
                    const selectedItem = itemMasterEntries.find((item) => item.ItCode === Number(value));
                    if (selectedItem) {
                        const packingEntry = packingMasterEntries.find(
                            (packing) => packing.PackingCode === selectedItem.PackingCode
                        );
                        if (packingEntry) {
                            const conversionFactor = packingEntry.ConversionFactor || 0;
                            updatedRow.PerKg = (conversionFactor * updatedRow.Qty).toFixed(2);
                        }
                    }
                }
    
                if (field === 'Qty') {
                    const selectedItem = itemMasterEntries.find((item) => item.ItCode === row.RawItCode);
                    if (selectedItem) {
                        const packingEntry = packingMasterEntries.find(
                            (packing) => packing.PackingCode === selectedItem.PackingCode
                        );
                        if (packingEntry) {
                            const conversionFactor = packingEntry.ConversionFactor || 0;
                            updatedRow.PerKg = (conversionFactor * parseFloat(value || 0)).toFixed(2);
                        }
                    }
                }
    
                return updatedRow;
            }
            return row;
        });
        setRows(updatedRows);
    };
    
    const addRow = () => {
        setRows([...rows, { RawItCode: 0, Qty: 0.0, PerKg: 0.0 }]);
    };

    const removeRow = (index) => {
        const newRows = rows.filter((_, i) => i !== index);
        setRows(newRows);
    };

    /* const totalQty = rows.reduce((total, row) => total + row.Qty, 0);
    const totalKg = rows.reduce((total, row) => total + row.PerKg, 0); */

    return (
        <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
            <ToastContainer />
            <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Production Formula Master</h1>
            <Grid item>
                {(props.canAdd === true) && (<Button
                    variant="contained"
                    className="view-button"
                    onClick={handleshowandhide}
                    sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
                >
                    {showGrid ? 'Add' : 'Back'}
                </Button>)}
            </Grid>
            {showGrid && <Grid item>
                <Button
                    variant="contained"
                    onClick={generatePDF}
                    sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
                >
                    Download PDF
                </Button>
            </Grid>}
            {showGrid && <Grid item>
                <Button
                    variant="contained"
                    sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
                >
                    Export
                </Button>
            </Grid>}
            {!showGrid && (
                <>
                    {/* <h2 style={{ fontSize: '20px', marginBottom: '6px' }}>
                        {formMode === 'add' ? 'Add' : 'Edit'}
                    </h2> */}
                    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1px' }}>

                        <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                            <label htmlFor="FinishedItCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>FinishedItCode</label>
                            <Autocomplete
                                options={itemMasterEntries}
                                getOptionLabel={(option) => option.ItName || ''}
                                value={itemMasterEntries.find((item) => item.ItCode == FinishedItCode) || null}
                                onChange={(event, newValue) => handleFinishedItCodeChange(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="FinishedItCode"
                                        sx={{
                                            marginBottom: '5px',
                                            width: '100%',
                                            '& .MuiInputBase-input': {
                                                color: 'black',
                                                padding: '1px',
                                                height: '1px'
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: 'black',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'black',
                                            },
                                            '& .MuiSvgIcon-root': {
                                                color: 'black',
                                            },
                                            backgroundColor: 'white'
                                        }}
                                    />
                                )}
                                sx={{ width: '30%' }}
                                isOptionEqualToValue={(option, value) => option.ItCode === value.ItCode}
                            />
                        </div>
                        <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                            <label htmlFor="PerQty" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
                                PerQty
                            </label>
                            <input
                                type="number"
                                value={PerQty}
                                onChange={(e) => setPerQty(e.target.value)}
                                placeholder="PerQty"
                                style={{ marginBottom: '5px', padding: '5px', width: '100px' }}
                            />
                        </div>
                        <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                            <label htmlFor="Narration" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
                                Narration
                            </label>
                            <input
                                type="text"
                                value={Narration}
                                onChange={(e) => setNarration(e.target.value)}
                                placeholder="Narration"
                                style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
                            />
                        </div>

                        <div style={{
                            overflow: 'auto',
                            maxHeight: '400px',
                            width: '100%',
                            margin: '8px auto',
                            padding: '8px',
                            borderRadius: '5px',
                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)'
                        }}>
                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                border: '1px solid #333',
                                tableLayout: 'fixed'
                            }}>
                                <thead style={{ backgroundColor: '#1168AA', color: 'white', position: 'sticky', top: 0, zIndex: 10 }}>
                                    <tr>
                                        <th style={{ width: '70px', border: '1px solid #333', padding: '6px', textAlign: 'left' }}>SrNo.</th>
                                        <th style={{ border: '1px solid #333', padding: '6px'/* , textAlign: 'left' */ }}>Raw Item</th>
                                        <th style={{ border: '1px solid #333', padding: '6px'/* , textAlign: 'left'  */}}>Qty</th>
                                        <th style={{ border: '1px solid #333', padding: '6px'/* , textAlign: 'left'  */}}>Weight</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((row, index) => (
                                        <tr key={index}>
                                            <td style={{ width: '45px', padding: '4px', border: '1px solid #333', textAlign: 'center' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '4px', width: '100%' }}>
                                                    <span style={{ fontSize: '0.8rem' }}>{index + 1}</span>
                                                    <IconButton
                                                        onClick={() => removeRow(index)}
                                                        aria-label="delete"
                                                        sx={{ padding: '4px' }}
                                                    >
                                                        <DeleteIcon sx={{ color: 'red', fontSize: '1.2rem' }} />
                                                    </IconButton>
                                                </div>
                                            </td>
                                            <td style={{ border: '1px solid #333', padding: '4px' }}>
                                                <Autocomplete
                                                    options={itemMasterEntries}
                                                    getOptionLabel={(option) => option.ItName || ''}
                                                    value={itemMasterEntries.find((item) => item.ItCode === row.RawItCode) || null}
                                                    onChange={(event, newValue) => {
                                                        if (newValue) {
                                                            handleRowChange(index, 'RawItCode', newValue.ItCode);
                                                        } else {
                                                            handleRowChange(index, 'RawItCode', ''); // Reset if no value is selected
                                                        }
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder="RawItCode"
                                                            sx={{
                                                                marginBottom: '5px',
                                                                width: '100%',
                                                                '& .MuiInputBase-input': {
                                                                    color: 'black',
                                                                    padding: '1px',
                                                                    height: '1px'
                                                                },
                                                                '& .MuiInputLabel-root': {
                                                                    color: 'black',
                                                                },
                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                    border: 'none',
                                                                },
                                                                '& .MuiSvgIcon-root': {
                                                                    color: 'black',
                                                                },
                                                                backgroundColor: 'white',
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid #333', padding: '4px' }}>
                                                <input
                                                    type="number"
                                                    step='0.1'
                                                    value={row.Qty}
                                                    onChange={(e) => handleRowChange(index, 'Qty', e.target.value)}
                                                    placeholder="Qty"
                                                    style={{ padding: '5px', width: '100%', border:'none', textAlign: 'right' }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid #333', padding: '4px' }}>
                                                <input
                                                    type="number"
                                                    value={row.PerKg}
                                                    onChange={(e) => handleRowChange(index, 'PerKg', e.target.value)}
                                                    placeholder="PerKg"
                                                    style={{ padding: '5px', width: '100%', border:'none', textAlign: 'right' }}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                    {/* <tr>
                                        <td colSpan={2} style={{ border: '1px solid #333', padding: '6px', textAlign: 'center' }}>
                                            <strong>Total</strong>
                                        </td>
                                        <td style={{ border: '1px solid #333', padding: '6px', textAlign: 'right' }}>
                                            <strong>{totalQty.toFixed(2)}</strong>
                                        </td>
                                        <td colSpan={1} style={{ border: '1px solid #333', padding: '6px' }}></td>
                                    </tr> */}

                                </tbody>
                                <tfoot>
                                    <tr style={{
                                        position: 'sticky',
                                        bottom: 0,
                                        zIndex: 10,
                                        backgroundColor: '#f1f1f1'
                                    }}>
                                        <td colSpan={2} style={{ border: '1px solid #333', padding: '6px', textAlign: 'center' }}>
                                            <strong>Total</strong>
                                        </td>
                                        <td style={{ border: '1px solid #333', padding: '6px', textAlign: 'right' }}>
                                            <strong>{totalQty.toFixed(2)}</strong>
                                        </td>
                                        <td style={{ border: '1px solid #333', padding: '6px', textAlign: 'right' }}>
                                            <strong>{parseFloat(totalKg).toFixed(2)}</strong>
                                        </td>
                                    </tr>
                                    <tr style={{
                                        position: 'sticky',
                                        bottom: 0,
                                        zIndex: 11,
                                        backgroundColor: '#f1f1f1'
                                    }}>
                                        <td colSpan={4} style={{ textAlign: "left", padding: "2px", border: "1px solid #333" }}>
                                            <button
                                                onClick={addRow}
                                                style={{
                                                    backgroundColor: "white",
                                                    color: "black",
                                                    padding: "4px 12px",
                                                    border: "none",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "5px",
                                                }}
                                            >
                                                ➕ Add Row
                                            </button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <div>
                        {/* <button
                            type="button"
                            onClick={addRow}
                            style={{
                                padding: '10px 20px',
                                width: '120px',
                                marginTop: '10px',
                                marginRight: '20px',
                                backgroundColor: '#1168AA',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                            }}
                        >
                            Add Row
                        </button> */}
                        <button
                            className={formMode === 'add' ? 'add-button' : 'update-button'}
                            onClick={handleSaveProduct}
                            style={{
                                padding: '10px 20px',
                                fontSize: '16px',
                                backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                borderRadius: '5px',
                                marginBottom: '10px',
                            }}
                        >
                            {formMode === 'add' ? 'Add' : 'Update'}
                        </button>
                        <button
                            className="view-button"
                            onClick={handleCancel}
                            style={{
                                padding: '10px 20px',
                                fontSize: '16px',
                                backgroundColor: '#f44336',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                marginLeft: '10px',
                                marginBottom: '10px',
                                borderRadius:'5px'
                            }}
                        >
                            Cancel
                        </button>
                    </div>

                </>
            )}
            {showGrid && (
                <div ref={componentPDF} style={{ width: '100%' }}>
                    <h2>Entries</h2>
                    <table
                        style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            border: '1px solid #ccc',
                        }}
                    >
                        <thead>
                            <tr style={{ background: '#f2f2f2', color: 'black' }}>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    SrNo.
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    FinishedItCode
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    PerQty
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                    className="print-hide"
                                >
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {ProductMasterEntries.reduce((accumulator, current) => {
                                const x = accumulator.find(item => item.FinishedItCode === current.FinishedItCode);
                                if (!x) {
                                    return accumulator.concat([current]);
                                } else {
                                    return accumulator;
                                }

                            }, []).map((caste, index) => {
                                const selectedGroup = itemMasterEntries.find(group => group.ItCode == caste.FinishedItCode);
                                return (
                                    <tr key={caste.FinishedItCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                                        <td style={{ padding: '6px', border: '1px solid #ccc' }}>{index + 1} </td>
                                        <td style={{ padding: '6px', border: '1px solid #ccc' }}>{selectedGroup ? `${selectedGroup.ItName}` : ''} </td>
                                        <td style={{ padding: '6px', border: '1px solid #ccc' }}>{caste.PerQty}</td>

                                        <td className="print-hide" style={{ border:'1px solid #ccc' }}>
                                            {(props.canEdit === true) && (<button
                                                className='action-btn btn-edit'
                                                onClick={() => setEditForm(caste)}
                                            >
                                                Edit
                                            </button>)}
                                            {(props.canDelete === true) && (<button
                                                className='action-btn btn-delete'
                                                //onClick={() => deleteProduct(caste.FormulaNo)}
                                                onClick={() => {
                                                    setDeleteEntryNo(caste.FinishedItCode);
                                                    setOpenConfirmation(true);
                                                }}
                                            >
                                                Delete
                                            </button>)}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            {<Dialog
                open={openConfirmation}
                onClose={() => setOpenConfirmation(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"CONFIRM DELETE"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to DELETE this Entry ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                        Cancel
                    </Button>
                    <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>}
        </div>
    );
};
export default ProdFormulaMaster;